/**
 * Refresh OAuth tokens using the provided refresh_token.
 * On success, `onLogin` runs first, then `nextAction(newAccessToken)` so callers can
 * retry requests before React re-renders with the new token.
 */
export const refreshAuthToken = (
  refreshToken,
  client_id,
  redirect_uri,
  code_verifier,
  path,
  setUserKey,
  setTokenRefreshing,
  nextAction,
  setLoading,
  onLogin,
  onLogout,
) => {
  if (!refreshToken) {
    return
  }

  const myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded")
  const urlencoded = new URLSearchParams()
  urlencoded.append("grant_type", "refresh_token")
  urlencoded.append("redirect_uri", redirect_uri)
  urlencoded.append("code_verifier", code_verifier)
  urlencoded.append("client_id", client_id)
  urlencoded.append("refresh_token", refreshToken)
  if (path) urlencoded.append("state", path)

  if (setTokenRefreshing) {
    setTokenRefreshing(true)
  }
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  }
  fetch("/api/auth/token", requestOptions)
    .then(response => response.text())
    .then(result => {
      if (result) {
        const data = JSON.parse(result)
        if (data?.access_token) {
          const authTime = String(Date.now())
          console.log("Token refreshed at: ", new Date(Number(authTime)).toLocaleString())
          const idTok = data?.id_token ?? ""
          const refreshTok = data?.refresh_token ?? ""
          if (onLogin) {
            onLogin(data.access_token, authTime, idTok, refreshTok)
          }
          if (nextAction) {
            nextAction(data.access_token)
          }
          if (setUserKey)
            setUserKey({
              id: data?.access_token,
              time: Date.now(),
              idTokenForLogout: data?.id_token,
              refresh_token: data?.refresh_token,
            })
          if (setTokenRefreshing) setTokenRefreshing(false)
          if (setLoading) setLoading(false)
        } else {
          if (onLogout) onLogout()

          if (setTokenRefreshing) setTokenRefreshing(false)
          if (setLoading) setLoading(false)
        }
      }
    })
    .catch(error => {
      console.log("error", error)
    })
}

export const refreshAuthTokenAsync = async ({
  refreshToken,
  client_id,
  redirect_uri,
  code_verifier,
  path,
}) => {
  if (!refreshToken) return null

  const myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded")

  const urlencoded = new URLSearchParams()
  urlencoded.append("grant_type", "refresh_token")
  urlencoded.append("redirect_uri", redirect_uri)
  urlencoded.append("code_verifier", code_verifier)
  urlencoded.append("client_id", client_id)
  urlencoded.append("refresh_token", refreshToken)
  urlencoded.append("state", path)

  try {
    const response = await fetch("/api/auth/token", {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    })

    const data = await response.json()

    if (data?.access_token) {
      const authData = {
        id: data.access_token,
        time: Date.now(),
        idTokenForLogout: data.id_token,
        refresh_token: data.refresh_token,
      }

      console.log("Token refreshed at: ", new Date(Number(authData.time)).toLocaleString())

      return authData
    }

    // TOKEN REFRESH FAILED
    console.error("Token refresh failed:", data?.error_description || data?.error || "Unknown error")
    return null
  } catch (error) {
    console.error("Token refresh request failed:", error)
    return null
  }
}
